import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { symbolWinResultDisplay } from "./scatter-result-display";

export function lineResultDisplay(record: Record, result: Result) {
    const scatterResult = symbolWinResultDisplay(record, result);

    scatterResult.innerHTML = "Line " + (result as LineResult).line + "<br>" + scatterResult.innerHTML;

    return scatterResult;
}
